import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { doc, getDoc, updateDoc, getDocs, where, query, collection } from 'firebase/firestore';
import { db, storage } from '../../Firebase/Firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import LoadingScreen from '../../Components/loading';
import Navbar from '../../Components/NavBarV2';
import Footer from '../../Components/footer';
import { FiUpload } from 'react-icons/fi';
import './LugaresAdministracion.css';

const EditarLugar = () => {
  const { idMarca, idLugar } = useParams(); // Asume ruta con ambos params
  const navigate = useNavigate();
  const [touchStartX, setTouchStartX] = useState(null);

  const [lugar, setLugar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [espacios, setEspacios] = useState([]);
  const [imagenActual, setImagenActual] = useState({});

  useEffect(() => {
    const fetchLugar = async () => {
      try {
        const lugarRef = doc(db, 'marca', idMarca, 'lugar', idLugar);
        const snap = await getDoc(lugarRef);
        if (snap.exists()) {
          setLugar(snap.data());
        } else {
          console.error('Lugar no encontrado');
        }
        setLoading(false);
      } catch (err) {
        console.error('Error al cargar lugar:', err);
        setLoading(false);
      }
    };
    const fetchEspacios = async () => {
      const espaciosRef = collection(db, "espacios");
      const q = query(espaciosRef, where("IdLugar", "==", idLugar));
      const snapshot = await getDocs(q);
      const espaciosData = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setEspacios(espaciosData);
    };

    fetchLugar();
    fetchEspacios();

  }, [idMarca, idLugar]);

  const handleFileChange = async (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const file = e.target.files[0];

    setUploading(true);

    try {
      if (lugar.ImagenUrl) {
        try {
          const oldRefPath = lugar.ImagenUrl.split('/o/')[1].split('?')[0];
          const oldRef = ref(storage, decodeURIComponent(oldRefPath));
          await deleteObject(oldRef);
          console.log('Imagen anterior eliminada');
        } catch (error) {
          console.warn('No se pudo eliminar imagen anterior:', error);
        }
      }

      const storageRef = ref(storage, `lugares/${idLugar}_${file.name}`);
      await uploadBytes(storageRef, file);
      const newUrl = await getDownloadURL(storageRef);

      setLugar((prev) => ({ ...prev, ImagenUrl: newUrl }));
      setUploading(false);
    } catch (error) {
      console.error('Error subiendo la imagen:', error);
      setUploading(false);
    }
  };

  const actualizarLugar = async () => {
    try {
      const lugarRef = doc(db, 'marca', idMarca, 'lugares', idLugar);
      await updateDoc(lugarRef, {
        ...lugar,
        FechaActualizacion: new Date(),
      });
      alert('✅ Lugar actualizado correctamente');
      navigate(`/admin/marca/${idMarca}`);
    } catch (err) {
      console.error('Error al actualizar:', err);
      alert('❌ Error al actualizar');
    }
  };

  if (loading || !lugar) return <LoadingScreen />;

  return (
    <>
      <Navbar />
      <div className="editar-lugar-container">
        <h2>Editar Lugar</h2>

        {/* Imagen */}
        <div className="logo-upload-container">
          {lugar.ImagenUrl && (
            <img
              src={lugar.ImagenUrl}
              alt="Imagen Lugar"
              className="logo-preview"
            />
          )}
          <label htmlFor="imagen-upload" className="logo-upload-label" title="Cambiar imagen">
            <FiUpload size={28} />
          </label>
          <input
            id="imagen-upload"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            disabled={uploading}
          />
        </div>

        <label>Nombre Lugar:</label>
        <input
          type="text"
          value={lugar.NombreLugar}
          onChange={(e) => setLugar({ ...lugar, NombreLugar: e.target.value })}
        />

        <label>Ciudad:</label>
        <input
          type="text"
          value={lugar.CiudadLugar}
          onChange={(e) => setLugar({ ...lugar, CiudadLugar: e.target.value })}
        />

        <label>Sector:</label>
        <input
          type="text"
          value={lugar.Sector}
          onChange={(e) => setLugar({ ...lugar, Sector: e.target.value })}
        />

        <label>Dirección:</label>
        <textarea
          value={lugar.Direccion}
          onChange={(e) => setLugar({ ...lugar, Direccion: e.target.value })}
        ></textarea>

        <button onClick={actualizarLugar} disabled={uploading}>
          {uploading ? 'Subiendo imagen...' : 'Guardar cambios'}
        </button>
      </div>
      <div className="espacio-laofi-container">
        <button
            className="btn-membresias"
            onClick={() => navigate(`/proveedor/marca/${idMarca}/lugar/${idLugar}/membresias`)}
          >
            🌟 Membresías
          </button>
          <button
            className="btn-membresias"
            onClick={() => navigate(`/proveedor`)}
          >
             Agregar Nuevo Espacio
          </button>
        <h3 className="espacio-laofi-title">Espacios disponibles</h3>
        <div className="espacio-laofi-grid">
          
          {espacios.map((espacio) => {
            const total = espacio.Imagenes.length;
            const currentIndex = imagenActual[espacio.id] || 0;

            const handlePrev = (e) => {
              e.preventDefault();
              setImagenActual((prev) => ({
                ...prev,
                [espacio.id]: currentIndex === 0 ? total - 1 : currentIndex - 1,
              }));
            };

            const handleNext = (e) => {
              e.preventDefault();
              setImagenActual((prev) => ({
                ...prev,
                [espacio.id]: currentIndex === total - 1 ? 0 : currentIndex + 1,
              }));
            };

            const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);

            const handleTouchEnd = (e) => {
              const touchEndX = e.changedTouches[0].clientX;
              const diff = touchStartX - touchEndX;
              if (diff > 30) handleNext(e);
              else if (diff < -30) handlePrev(e);
            };


            return (
              <Link to={`/proveedor/marca/${idMarca}/lugar/${idLugar}/espacio/${espacio.id}`} key={espacio.id}>
                <div className="espacio-laofi-card">
                  <h4 className="espacio-laofi-nombre">{espacio.NombreEspacio}</h4>
                  <div className="espacio-laofi-slider">
                    <button onClick={handlePrev} className="slider-button">‹</button>
                    <img
                      src={espacio.Imagenes[currentIndex]}
                      alt={`Foto ${currentIndex}`}
                      className="espacio-laofi-img"
                      onTouchStart={handleTouchStart}
                      onTouchEnd={handleTouchEnd}
                    />
                    <button onClick={handleNext} className="slider-button">›</button>
                  </div>
                  <div className="slider-indicadores">
                    {espacio.Imagenes.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === currentIndex ? "active" : ""}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setImagenActual((prev) => ({
                            ...prev,
                            [espacio.id]: i,
                          }));
                        }}
                      >

                      </span>
                    ))}
                  </div>
                  <p>Capacidad: {espacio.CapacidadMin} - {espacio.CapacidadMax} personas</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default EditarLugar;
